const LoadingComponent = () => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-black text-center text-gray-800">
    <h1 className=" text-7xl font-extrabold">Please Wait</h1>
    <p className="text-3xl">Page is Loading</p>
  </div>
);

export default LoadingComponent;
